module.exports = __webpack_public_path__ + "static/media/loc2_img4.ffa980a8.jpg";